import { MapTo } from '@adobe/aem-react-editable-components';
import TileGrid, { TileGridProps } from './TileGrid';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';

const RESOURCE_TYPE = 'learning-academy/components/custom/tilegrid';

const TileGridEmptyFn = (props: TileGridProps) => !props || (!props.heading && !props.tiles?.length);

const EditConfig = {
  emptyLabel: 'Tile Grid: Please configure the component',
  isEmpty: TileGridEmptyFn,
};

export default MapTo<TileGridProps>(RESOURCE_TYPE)(...WithEmptyPlaceholder(TileGrid, EditConfig));
